import React from 'react';
import type { OnChangeParams, SelectProps, Value } from 'baseui/select';
import { Select, SIZE, TYPE } from 'baseui/select';
import type { SearchOptionWithIcon } from '../common';
import { RenderSearchOptionLabel } from '../common';
export type LabelSearchSelectProps = {
  options: SearchOptionWithIcon[];
  value: Value;
  onChange: (params: OnChangeParams) => void;
  onInputChange?: SelectProps['onInputChange'];
  overrides?: SelectProps['overrides'];
  placeholder?: string;
};
const defaultOverrides: SelectProps['overrides'] = {
  ControlContainer: {
    style: ({
      $theme
    }) => ({
      borderRadius: $theme.borders.radius500
    })
  },
  DropdownListItem: {
    style: ({
      $theme
    }) => ({
      padding: `${$theme.sizing.scale100} ${$theme.sizing.scale600}`
    })
  },
  ValueContainer: {
    style: ({
      $theme
    }) => ({
      paddingTop: $theme.sizing.scale100,
      paddingBottom: $theme.sizing.scale100
    })
  }
};
export const LabelSearchSelect = ({
  options,
  value,
  onChange,
  onInputChange,
  overrides,
  placeholder = 'Search for a class'
}: LabelSearchSelectProps) => {
  const mergedOverrides = overrides ? {
    ...defaultOverrides,
    ...overrides
  } : defaultOverrides;
  return <Select options={options} value={value} placeholder={placeholder} size={SIZE.compact} type={TYPE.search} clearable labelKey="label" valueKey="value" onChange={onChange} onInputChange={onInputChange} onCloseResetsInput={false} onBlurResetsInput={false} overrides={mergedOverrides} getOptionLabel={option => <RenderSearchOptionLabel {...(option.option as SearchOptionWithIcon)} />} />;
};